import router from '../router';
import axios from "axios";

function logout()
{
	store.commit('UserLogout');
}

const CancelToken = axios.CancelToken;
let connectionStateRequest;
let connectionsRequest;
let mandateStateRequest;
let dataStateRequest;
let dataStateExpetedRequest;
let dataStateOperatorsRequest;
let actionsRequest;
let expectsRequest;
let malfunctionsRequest;
let malfunctionsStateRequest;
let operatorMalfunctionsRequest;

export default {
	cancelLoading()
	{
		if(connectionStateRequest != undefined)
		{
			connectionStateRequest();
		}
		if(connectionsRequest != undefined)
		{
			connectionsRequest();
		}
		if(mandateStateRequest != undefined)
		{
			mandateStateRequest();
		}
		if(dataStateRequest != undefined)
		{
			dataStateRequest();
		}
		if(dataStateExpetedRequest != undefined)
		{
			dataStateExpetedRequest();
		}
		if(dataStateOperatorsRequest != undefined)
		{
			dataStateOperatorsRequest();
		}
		if(actionsRequest != undefined)
		{
			actionsRequest();
		}
		if(expectsRequest != undefined)
		{
			expectsRequest();
		}
		if(malfunctionsRequest != undefined)
		{
			malfunctionsRequest();
		}
		if(malfunctionsStateRequest != undefined)
		{
			malfunctionsStateRequest();
		}
		if(operatorMalfunctionsRequest != undefined)
		{
			operatorMalfunctionsRequest();
		}
	},
	loadConnectionState(context, data){
		let url = window.ApiUrl + '/management/connection/states';

		return new Promise((resolve, reject) =>
		{
			if(connectionStateRequest != undefined)
			{
				connectionStateRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { connectionStateRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},
	loadConnections(context, data){
		let url = window.ApiUrl + '/management/connection/list';

		return new Promise((resolve, reject) =>
		{
			if(connectionsRequest != undefined)
			{
				connectionsRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { connectionsRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},
	loadMandateState(context, data){
		let url = window.ApiUrl + '/management/mandate/states';

		return new Promise((resolve, reject) =>
		{
			if(mandateStateRequest != undefined)
			{
				mandateStateRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { mandateStateRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},
	loadDataState(context, data){
		let url = window.ApiUrl + '/management/data/state';

		return new Promise((resolve, reject) =>
		{
			if(dataStateRequest != undefined)
			{
				dataStateRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { dataStateRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},
	loadDataExpendedState(context, data){
		let url = window.ApiUrl + '/management/request/states/extended';

		return new Promise((resolve, reject) =>
		{
			if(dataStateExpetedRequest != undefined)
			{
				dataStateExpetedRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { dataStateExpetedRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},
	loadDataStateOperators(context, data){
		let url = window.ApiUrl + '/management/request/states/operators';

		return new Promise((resolve, reject) =>
		{
			if(dataStateOperatorsRequest != undefined)
			{
				dataStateOperatorsRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { dataStateOperatorsRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},

	loadActions(context, data){
		let url = window.ApiUrl + '/management/action/list';

		return new Promise((resolve, reject) =>
		{
			if(actionsRequest != undefined)
			{
				actionsRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { actionsRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},

	loadExpects(context, data){
		let url = window.ApiUrl + '/management/request/states/list';

		return new Promise((resolve, reject) =>
		{
			if(expectsRequest != undefined)
			{
				expectsRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { expectsRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},

	loadMalfunctions(context, data){
		let url = window.ApiUrl + '/management/malfunctions/list';

		return new Promise((resolve, reject) =>
		{
			if(malfunctionsRequest != undefined)
			{
				malfunctionsRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { malfunctionsRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},

	loadMalfunctionsState(context, data){
		let url = window.ApiUrl + '/management/malfunctions/overview';

		return new Promise((resolve, reject) =>
		{
			if(malfunctionsStateRequest != undefined)
			{
				malfunctionsStateRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { malfunctionsStateRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},

	loadOperatorMalfunctions(context, data){
		let url = window.ApiUrl + '/management/malfunctions/operators';

		return new Promise((resolve, reject) =>
		{
			if(operatorMalfunctionsRequest != undefined)
			{
				operatorMalfunctionsRequest();
			}
			axios.post(url, data, { responseType: 'json', cancelToken: new CancelToken(function executor(c) { operatorMalfunctionsRequest = c })
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},


	updateAction(context, data)
	{
		let url = window.ApiUrl + '/management/action/update/' + data.action.id;

		return new Promise((resolve, reject) =>
		{
			axios.post(url, data.request, { responseType: 'json'
    		  }).
				then(function (response){
					resolve(response.data);
				}).catch(function (error){
					reject(error);
				});
		});
	},

    UserLogin(context, data) { // Login.vue en LoginDialog.vue

		let url = window.ApiUrl + '/oauth/token';
		context.commit('startLoading', 'Inlog gegevens worden gecontroleerd.');
        return new Promise((resolve, reject) => {
			axios.post(url, data, { responseType: 'json'
      }).
				then(function (response){
					context.commit('stopLoading');
					context.commit('UserLogin', response.data.access_token);
					let url = window.ApiUrl + '/control/profile';
					axios.get(url, { responseType: 'json' }).
							then(function (response){
								context.commit('UserData', response.data.user);
								resolve(response.data);
							}).catch(function (error){
						});
				}).catch(function (error){
					context.commit('stopLoading');
					reject(error);
				});
		});
    },

    UserLogout(context) { // components/Toolbar.vue
		let url = window.ApiUrl + '/control/logout';
        return new Promise((resolve, reject) => {
			axios.get(url, { responseType: 'json'}).
				then(function (response){
					logout();
					router.push({name: 'authentication'});
					context.commit('stopLoading');
					resolve();
				}).catch(function (error){
					context.commit('stopLoading');
					reject(error);
				});
		});
    },

	UserRequestPassword(context, data) // views/Login.vue
	{
		let url = window.ApiUrl + '/control/request/password';
		context.commit('startLoading', 'E-mail wordt verstuurd.');
        return new Promise((resolve, reject) => {
			axios.post(url, data, { responseType: 'json'}).
				then(function (response){
					context.commit('stopLoading');
					resolve(response.data);
				}).catch(function (error){
					context.commit('stopLoading');
					reject(error.response);
				});
		});
	},

	UserResetPassword(context, data) //views/Password.vue
	{
		let url = window.ApiUrl + '/control/reset/password';
		context.commit('startLoading', 'Het wachtwoord wordt gezet.');
        return new Promise((resolve, reject) => {
			axios.post(url, data, { responseType: 'json'}).
				then(function (response){
					context.commit('stopLoading');
					resolve(response.data);
				}).catch(function (error){
					context.commit('stopLoading');
					reject(error);
				});
		});
	},
	LoadExpects(context, data)
	{
		let url = window.ApiUrl + '/control/expects/' + data.connection;
        return new Promise((resolve, reject) => {
				axios.post(url, data, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},

	LoadAddress(context, address)
	{
		let url = window.ApiUrl + '/control/address/' + address;
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},
	
	LoadErrors(context, data)
	{
		let url = window.ApiUrl + '/control/edsn/errors';
        return new Promise((resolve, reject) => {
				axios.post(url, data, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},
	
	LoadMaintenance(context, data)
	{
		let url = window.ApiUrl + '/control/maintenance';
        return new Promise((resolve, reject) => {
				axios.post(url, data, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},
	
	LoadOperators(context)
	{
		let url = window.ApiUrl + '/control/operators';
		context.commit('startLoading', 'De netbeheerders worden geladen.');
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
						context.commit('stopLoading');
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
						context.commit('stopLoading');
					});
			});
	},
	
	addMaintenance(context, data)
	{
		let url = window.ApiUrl + '/control/maintenance/add';
		context.commit('startLoading', 'Het onderhoud wordt toegevoegd.');
        return new Promise((resolve, reject) => {
				axios.post(url, data, { responseType: 'json'
		  }).
					then(function (response){
						context.commit('stopLoading');
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						context.commit('stopLoading');
						reject(error.response.data);
					});
			});
	},
	
	LoadCompanies(context, data)
	{
		let url = window.ApiUrl + '/control/companies';
		context.commit('startLoading', 'De bedrijven worden geladen.');
        return new Promise((resolve, reject) => {
				axios.post(url, data, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
						context.commit('stopLoading');
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
						context.commit('stopLoading');
					});
			});
	},
	
	addCompany(context, data)
	{
		let url = window.ApiUrl;
		if(data.id == undefined)
		{
			url += '/control/companies/add';
		}
		else
		{
			url += '/control/companies/edit/' + data.id;
		}
		context.commit('startLoading', 'Het bedrijf wordt toegevoegd/aangepast.');
        return new Promise((resolve, reject) => {
				axios.post(url, data, { responseType: 'json'
		  }).
					then(function (response){
						context.commit('stopLoading');
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						context.commit('stopLoading');
						reject(error.response.data);
					});
			});
	},
	
	removeCompany(context, data)
	{
		let url = window.ApiUrl + '/control/companies/remove/' + data;
		context.commit('startLoading', 'Het bedrijf wordt toegevoegd.');
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						context.commit('stopLoading');
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						context.commit('stopLoading');
						reject(error.response.data);
					});
			});
	},
	
	LoadProfile(context)
	{
		let url = window.ApiUrl + '/control/profile';
		context.commit('startLoading', 'Het profiel wordt geladen.');
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
						context.commit('stopLoading');
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
						context.commit('stopLoading');
					});
			});
	},
	
	changePassword(context, data)
	{
		let url = window.ApiUrl + '/control/profile/password';
		context.commit('startLoading', 'Het wachtwoord wordt aangepast.');
        return new Promise((resolve, reject) => {
				axios.post(url, data, { responseType: 'json'
		  }).
					then(function (response){
						context.commit('stopLoading');
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						context.commit('stopLoading');
						reject(error.response.data);
					});
			});
	},
	
	fetchPermissions(context)
	{
		let url = window.ApiUrl + '/control/permissions';
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},
	
	LoadCompanyList(context)
	{
		let url = window.ApiUrl + '/control/company/list';
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},
	
	renewAddress(context, address)
	{
		context.commit('startLoading', 'Het mandaat wordt vernieuwd.');
		let url = window.ApiUrl + '/control/address/renew/' + address;
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
						context.commit('stopLoading');
					}).catch(function (error){
						context.commit('stopLoading');
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},
	
	LoadErrorStates(context)
	{
		let url = window.ApiUrl + '/control/edsn/error/states';
        return new Promise((resolve, reject) => {
				axios.get(url, { responseType: 'json'
		  }).
					then(function (response){
						resolve(response.data);
					}).catch(function (error){
						if(error.response.status == 401)
						{
							logout();
							router.push({name: 'authentication'});
						}
						reject(error);
					});
			});
	},
}
